//@ts-check

/** @type import("../../types/icons/glyphs").PartialGlyphs */
export default {};
